import Options from './Options';

const AVAILABLE_TYPES = {
    'similar': '0',
    'image': '1',
};

const AVAILABLE_QUERIES = [
    'similar',
    'search',
];

export const AVAILABLE_VIEWS = [
    'row',
    'grid',
];

export default class OffersOptions extends Options {
    constructor(options) {
        super(options);
    }
    get view() {
        const fallback = 'row';
        let view = this._options.view || fallback;
        if (AVAILABLE_VIEWS.includes(view) === false) {
            console.warn(`Unknown view "${view}", switching to "${fallback}"`);
            view = fallback;
        }
        return view;
    }
    get type() {
        const availableTypeKeys = Object.keys(AVAILABLE_TYPES);
        const fallback = availableTypeKeys[0];
        let type = this._options.type || fallback;
        if (type && availableTypeKeys.includes(type) === false) {
            console.warn(`Unknown type "${type}", switching to "${fallback}"`);
        }
        return {
            type: this._options.type,
            apiCode: AVAILABLE_TYPES[this._options.type],
        };
    }
    get query() {
        if (AVAILABLE_QUERIES.includes(this._options.query) === false) {
            const fallback = AVAILABLE_QUERIES[0];
            console.warn(`Unknown query "${this._options.query}", switching to "${fallback}"`);
            return fallback;
        }
        return this._options.query;
    }
    get offerId() {
        return typeof this._options.offerId === 'function' ? this._options.offerId() : this._options.offerId;
    }
    get params() {
        return this._options.params || {};
    }
}